import React from 'react';
import { Col, Row } from 'reactstrap';
import LeftNavigation from './LeftNavigation';
import MainContent from './MainContent';
import RightBanners from './RightBanners';

interface Props {
    titleTranslateId: string
}

const ContentLayout = (props: React.PropsWithChildren<Props>) => {
    return (
        <>
            <LeftNavigation />

            <MainContent titleTranslateId={props.titleTranslateId}>
                <Row>
                    <Col xl={8} lg={12} className="mb-4">
                        {props.children}
                    </Col>
                    <Col xl={4} lg={12}>
                        <RightBanners />
                    </Col>
                </Row>
            </MainContent>
        </>
    );
}

export default ContentLayout;
